module.exports = __webpack_public_path__ + "static/media/hangingCloud.f18547f2.png";